/* eslint-disable react/jsx-curly-brace-presence */

import React /* { useState, useEffect } */ from 'react';
import { Grid, Typography, Button, Box, Dialog, DialogContent } from '@material-ui/core';
import ClearTwoToneIcon from '@material-ui/icons/ClearTwoTone';
import { useNavigate, useParams } from 'react-router-dom';
// import PropTypes from 'prop-types';
// import Cookies from 'js-cookie';

import useStyles from './Calendar.style';
import useClassInstance from '../../../hooks/useClassInstance';

const ABIInvalidPackModal = (/* { isABP } */) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { eventId } = useParams();
  // const [userData, setUserData] = useState({});

  const {
    classInstanceStates: { invalidPackModal, invalidPackMessageModal },
    setInvalidPackModal,
  } = useClassInstance();

  /* useEffect(() => {
    const userCookie = Cookies.get('user');
    if (userCookie) {
      const parsedUser = JSON.parse(atob(userCookie));
      setUserData(parsedUser);
    }
  }, []); */

  return (
    <Box px={2} py={1}>
      <Dialog
        className={classes.modalContainer}
        maxWidth="sm"
        open={invalidPackModal}
        onClose={() => setInvalidPackModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        BackdropProps={{
          invisible: true,
        }}
        disableEscapeKeyDown
      >
        <DialogContent>
          <Button
            onClick={() => setInvalidPackModal(false)}
            color="primary"
            className={classes.closeBtn}
          >
            <ClearTwoToneIcon />
          </Button>
          <Grid container direction="column" justify="space-between" className={classes.container}>
            <Grid container spacing={4} direction="row" alignItems="stretch">
              <Grid item xs={12}>
                <Grid container spacing={3} alignItems="center" direction="column">
                  <Grid item>
                    <img
                      className={classes.img}
                      src={require('../../../assets/images/smartstudio-footer-logo.svg').default}
                      alt="Smart Studio"
                    />
                  </Grid>
                  <Grid item>
                    <If condition={invalidPackMessageModal}>
                      <Typography variant="h1" className={classes.invalidPack}>
                        {invalidPackMessageModal}
                      </Typography>
                    </If>
                    <If condition={!invalidPackMessageModal}>
                      <Typography variant="h1" className={classes.invalidPack}>
                        {`You don't have a package on file for this session.`}
                        <br />
                        Would you like to purchase a new package?
                        {/* {userData.dob !== null
                          ? */}
                        {/*  : 'Please complete your profile to continue.'} */}
                        {/*  <If condition={userData.dob !== null}> */}
                        {/* </If> */}
                      </Typography>
                    </If>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="center">
              <Grid item>
                <div className={classes.wrapper}>
                  <If condition={!invalidPackMessageModal}>
                    <Button
                      type="submit"
                      className={`${classes.button} ${classes.invalidPackBtn}`}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setInvalidPackModal(false);
                        /* if (isABP) {
                          if (userData.dob === null) {
                            navigate('../../../settings/account-details');
                          } else {
                            navigate('../../../settings/packages');
                          }
                        } else {
                          navigate('settings/packages');
                        } */
                        navigate(`../../../book-event/packages/${eventId}`);
                      }}
                    >
                      PURCHASE PACKAGE
                    </Button>
                  </If>
                  <If condition={invalidPackMessageModal}>
                    <Button
                      type="submit"
                      className={`${classes.button} ${classes.invalidPackBtn}`}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setInvalidPackModal(false);
                      }}
                    >
                      CLOSE
                    </Button>
                  </If>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
/* 
ABIInvalidPackModal.propTypes = {
  isABP: PropTypes.bool,
};

ABIInvalidPackModal.defaultProps = {
  isABP: false,
}; */

export default ABIInvalidPackModal;
